module.exports = __webpack_public_path__ + "static/media/roadmap.e5b7b744.png";